export default __webpack_public_path__ + "static/media/py.84f0d052.svg";